import type { CmsItem } from '~/types/cms';

export interface LinkMenu {
    url?: string | null;
    linkUrl?: string | null;
    linkText?: string | null;
    newWindow?: boolean | string | null;
    isEmpty?: boolean | null;
    isElement?: boolean | null;
    target?: string | null;
    title?: string | null;
    type?: string | null;
    element?: ElementMenu | null;
    customAttributes?: { [key: string]: string };
}

export interface ElementMenu {
    id?: string | null;
    title?: string | null;
    slug?: string | null;
    sectionHandle?: string | null;
}

export const useConvertedMenuLink = (link: LinkMenu | CmsItem): string => {
    const localePath = useLocalePath();
    const query: { [key: string]: string } = {};

    if (link.type == 'craft\\elements\\Entry' && link.element?.sectionHandle) {
        const slug = (link.element.slug || '').split('/').filter(Boolean);
        const objList: Record<string, any> = {
            home: {
                name: 'index',
                query: query
            },
            pages: {
                name: 'slug',
                query: query,
                params: {
                    slug
                }
            },
            locations: useLocationRouteTarget(link.element as CmsItem),
            news: {
                name: 'news-slug',
                query: query,
                params: {
                    slug: link.element.slug
                }
            }
        };

        const targetRoute = objList[link.element.sectionHandle];
        if (targetRoute) {
            return localePath(targetRoute);
        }
    }

    return link.url ?? link.linkUrl ?? '';
};
